<template>
  <div>
    <vs-prompt
      title="Add guest manually"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>First name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" v-model="dto.firstName" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Last name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" v-model="dto.lastName" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                :warning="!validateEmail(dto.email)"
                warning-text="E-mail not valid"
                class="inputx w-full"
                type="email"
                v-model="dto.email"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>

import validators from "@/views/mixins/validators";

export default {
  mixins: [validators],
  components: {},
  data() {
    return {
      dto: { firstName: "", lastName: "", email: "" },
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return (
        this.dto.firstName !== "" &&
        this.dto.lastName !== "" &&
        this.dto.email !== "" && this.validateEmail(this.dto.email)
      );
    },
  },
  methods: {
    
    show() {
      this.dto.firstName = "";
      this.dto.lastName = "";
      this.dto.email = "";
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();
      const id = await this.$store.dispatch("guestProfiles/create", this.dto);
      this.$vs.loading.close();
      this.$router
        .push({ name: "crm-guest-profile", params: { id: id } })
        .catch(() => {});
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
